import styled from '@emotion/styled'

export const AccountSelectWrapper = styled.div`
  width: 300px;
`
